class HeroReviewsSlider extends Theme.Component {
 constructor() {
    super();

    this.defineElements({
      slider: ".hero-reviews-slider",
      previous_button: "button:first-of-type",
      next_button: "button:last-of-type"
    });

    if (!this.elements.slider) {
      this.elements.slider = this.querySelector(".hero-reviews-slider");
    }

    this.elements.slider_items = this.querySelectorAll(".hero-reviews-slider-item");

    this.slider = null;
    this.lastWidth = 0;
    this.isBuilding = false;
  }

  connectedCallback() {
    if (!this.elements.slider) return;
    requestAnimationFrame(() => this.observer());
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }

    if (this.slider) {
      this.teardown();
    }
  }

  observer() {
    this.resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const width = Math.round(entry.contentRect.width);

        // Guard against the observer feedback loop: (re)building Flickity
        // mutates this element's geometry, which re-fires the ResizeObserver.
        // Skip hidden containers (width 0) and any resize where the observed
        // width hasn't actually changed (e.g. a height-only change from the
        // rebuild). Without this it destroys/rebuilds forever and freezes.
        if (width <= 0 || width === this.lastWidth) continue;
        this.lastWidth = width;

        if (this.isBuilding) continue;
        this.isBuilding = true;

        if (this.slider) {
          this.teardown();
        }

        this.setup(width);

        this.isBuilding = false;
      }
    });

    this.resizeObserver.observe(this.elements.slider);
  }

  setup(width) {
    let options = {
      cellAlign: 'center',
      contain: true,
      pageDots: true,
      prevNextButtons: false,
      wrapAround: false,
      groupCells: 1
    };

    // The stylesheet's height: 100% on the items resolves to 0 against
    // Flickity's not-yet-sized viewport, collapsing the gallery on the
    // first build. Measure with auto heights, then re-apply the 100%
    // that equalizes card heights once the viewport is sized.
    this.elements.slider_items.forEach((element) => {
      element.style.height = "auto";
    });

    this.slider = new Flickity(this.elements.slider, options);

    this.elements.slider_items.forEach((element) => {
      element.style.height = "100%";
    });
  }

  teardown() {
    if (this.slider) {
      this.slider.destroy();
      this.slider = null;
    }

    this.elements.slider_items.forEach((element) => {
      element.style.height = "auto";
    });
  }

  next() {
    if (this.slider) this.slider.next();
  }

  previous() {
    if (this.slider) this.slider.previous();
  }
}

customElements.define("component-hero-reviews-slider", HeroReviewsSlider);
